/* =====================================================================
   UUGI Education Program — shared data
   NOTE: Past (completed) programs are no longer held here — they are
   authored in the Umbraco back office (Education Program Detail pages) and
   rendered server-side by PastPrograms.cshtml. Only the upcoming programs
   remain as static data for the (still design-only) upcoming/partners
   sections; they will be moved to the back office in a later pass.
   window.UUGI_EDU.programs  — array of program objects
   window.UUGI_EDU.byId(id)  — lookup helper
   ===================================================================== */

(function () {

  var IMG = {
    lecture:    'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1200&q=80&auto=format&fit=crop',
    workshop:   'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=1200&q=80&auto=format&fit=crop',
    classroom:  'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1200&q=80&auto=format&fit=crop',
    students:   'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200&q=80&auto=format&fit=crop',
    collab:     'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=1200&q=80&auto=format&fit=crop',
    audience:   'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1200&q=80&auto=format&fit=crop',
    session:    'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80&auto=format&fit=crop',
    talk:       'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=1200&q=80&auto=format&fit=crop',
    stage:      'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=1200&q=80&auto=format&fit=crop',
    laptops:    'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=1200&q=80&auto=format&fit=crop',
    hall:       'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1200&q=80&auto=format&fit=crop',
    seminar:    'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=1200&q=80&auto=format&fit=crop'
  };

  // Gallery sets reused per program (workshop / classroom imagery)
  var GAL_A = [IMG.workshop, IMG.collab, IMG.students, IMG.laptops, IMG.classroom, IMG.session];
  var GAL_B = [IMG.lecture, IMG.audience, IMG.talk, IMG.hall, IMG.students, IMG.workshop];

  var programs = [

    /* ---------------------- UPCOMING ---------------------- */
    {
      id: 'marwadi-university',
      title: 'Umbraco Fundamentals Workshop',
      college: 'Marwadi University',
      crest: 'MU',
      city: 'Rajkot, Gujarat',
      date: '18 Jul 2026',
      iso: '2026-07-18',
      type: 'workshop',
      typeLabel: 'Workshop',
      status: 'upcoming',
      students: 140,
      image: IMG.classroom,
      banner: IMG.classroom,
      department: 'Faculty of Computer Applications',
      duration: 'Full day · 6 hours',
      sessions: 4,
      speakersCount: 3,
      hours: 6,
      regStatus: 'Open',
      regSeats: '140 seats · filling fast',
      regFee: 'Free for students',
      regDeadline: 'Register by 10 Jul 2026',
      countdownIso: '2026-07-18T10:00:00+05:30',
      summary: 'A hands-on Umbraco fundamentals workshop bringing modern CMS development to Saurashtra’s growing tech campuses.',
      objective: 'Equip students with a practical, build-along introduction to Umbraco and modern .NET web development.',
      audience: 'Computer Applications & Engineering students with basic C#.',
      overview: [
        'UUGI heads to Rajkot for the first time, partnering with Marwadi University to bring a full-day Umbraco fundamentals workshop to Saurashtra’s fast-growing tech community.',
        'Students will leave with a running Umbraco site and a clear picture of how their .NET coursework connects to industry work.'
      ],
      agenda: [
        { time: '10:00', title: 'Welcome & Umbraco Overview', desc: 'What Umbraco is, who uses it and why open source matters.' },
        { time: '11:00', title: 'Hands-on: First Install', desc: 'Spin up Umbraco locally and explore the back-office.' },
        { time: '13:30', title: 'Content Modelling Lab', desc: 'Build document types, templates and your first pages.' },
        { time: '15:30', title: 'Best Practices & Careers', desc: 'Industry patterns, certifications and Q&A.' }
      ],
      topics: ['Introduction to Umbraco', 'Content Management Fundamentals', 'Modern CMS Development', 'Industry Best Practices', 'Career Opportunities'],
      speakers: [
        { name: 'Neha Sridhar', role: 'Workshops Lead', org: 'UUGI Pune' },
        { name: 'Farhan Qureshi', role: 'Certified Developer', org: 'UUGI Mumbai' },
        { name: 'Tanvi Rao', role: 'Content & Community', org: 'UUGI Hyderabad' }
      ],
      expected: ['140 students trained on Umbraco fundamentals', 'A new UUGI chapter presence in Rajkot', 'Student community sign-ups across Saurashtra', 'Foundation for a follow-up advanced workshop']
    },
    {
      id: 'parul-university',
      title: 'Open-Source Careers Seminar',
      college: 'Parul University',
      crest: 'PU',
      city: 'Vadodara, Gujarat',
      date: '05 Aug 2026',
      iso: '2026-08-05',
      type: 'seminar',
      typeLabel: 'Seminar',
      status: 'upcoming',
      students: 300,
      image: IMG.seminar,
      banner: IMG.seminar,
      department: 'Parul Institute of Engineering & Technology',
      duration: 'Half day · 3 hours',
      sessions: 3,
      speakersCount: 2,
      hours: 3,
      regStatus: 'Open',
      regSeats: '300 seats',
      regFee: 'Free for students',
      regDeadline: 'Register by 28 Jul 2026',
      countdownIso: '2026-08-05T11:00:00+05:30',
      summary: 'A large-format seminar on open-source careers and the global Umbraco ecosystem for one of Gujarat’s biggest campuses.',
      objective: 'Inspire a large student audience to see open source and community as a serious, achievable career accelerator.',
      audience: 'Engineering & IT students across all years.',
      overview: [
        'Parul University opens its main auditorium for one of UUGI’s largest education seminars yet — a forward-looking session on open-source careers and the worldwide Umbraco community.',
        'With certification pathways and real alumni stories, the seminar aims to turn curiosity into concrete first steps.'
      ],
      agenda: [
        { time: '11:00', title: 'The Open-Source Opportunity', desc: 'How community and contribution shape modern careers.' },
        { time: '12:00', title: 'Why .NET & Umbraco', desc: 'The Indian market and the global ecosystem.' },
        { time: '13:00', title: 'Roadmaps & Q&A', desc: 'Certifications, portfolios and live questions.' }
      ],
      topics: ['Open-Source Careers', 'Why .NET & Umbraco', 'Certification Pathways', 'Building a Portfolio', 'Community as an Accelerator'],
      speakers: [
        { name: 'Rohan Mehta', role: 'Solutions Architect · Umbraco MVP', org: 'UUGI Pune' },
        { name: 'Sameer Khanna', role: 'Partnerships', org: 'UUGI Delhi' }
      ],
      expected: ['300+ students reached', 'Large-scale community sign-up drive', 'Certification study group for Vadodara', 'Groundwork for a hands-on workshop']
    },
    {
      id: 'daiict-gandhinagar',
      title: 'Composable Architecture Deep-Dive',
      college: 'DA-IICT',
      crest: 'DAI',
      city: 'Gandhinagar, Gujarat',
      date: '22 Aug 2026',
      iso: '2026-08-22',
      type: 'guest-lecture',
      typeLabel: 'Guest Lecture',
      status: 'upcoming',
      students: 100,
      image: IMG.lecture,
      banner: IMG.lecture,
      department: 'Information & Communication Technology',
      duration: '2 hours',
      sessions: 1,
      speakersCount: 1,
      hours: 2,
      regStatus: 'Filling fast',
      regSeats: '100 seats · limited',
      regFee: 'Free for students',
      regDeadline: 'Register by 15 Aug 2026',
      countdownIso: '2026-08-22T15:00:00+05:30',
      summary: 'An MVP-led guest lecture on composable, API-first architecture for ICT students at one of India’s top tech institutes.',
      objective: 'Give ICT students an advanced, real-world view of composable architecture and headless content delivery.',
      audience: 'B.Tech ICT, 3rd and 4th year.',
      overview: [
        'UUGI brings a three-time Umbraco MVP to DA-IICT for an advanced guest lecture on composable, API-first systems — the architecture behind today’s most ambitious digital platforms.',
        'Expect a technically rich session pitched at one of India’s most rigorous ICT student bodies.'
      ],
      agenda: [
        { time: '15:00', title: 'Composable Architecture 101', desc: 'From monoliths to composable systems.' },
        { time: '15:45', title: 'Headless Umbraco Live', desc: 'One content source, many channels.' },
        { time: '16:30', title: 'Deep-dive Q&A', desc: 'Architecture, scale and careers.' }
      ],
      topics: ['Composable Architecture', 'Headless & API-first CMS', 'Umbraco Heartcore', 'Multi-channel Delivery', 'Enterprise Patterns'],
      speakers: [
        { name: 'Ananya Kapoor', role: 'Principal Engineer · 3× Umbraco MVP', org: 'UUGI Bengaluru' }
      ],
      expected: ['100 ICT students reached', 'Advanced architecture exposure', 'Capstone project collaborations', 'Mentorship pipeline for top students']
    },
    {
      id: 'vgec-ahmedabad',
      title: 'Career Launchpad & Mock Interviews',
      college: 'Vishwakarma Government Engineering College',
      crest: 'VGEC',
      city: 'Ahmedabad, Gujarat',
      date: '14 Sep 2026',
      iso: '2026-09-14',
      type: 'career-session',
      typeLabel: 'Career Session',
      status: 'upcoming',
      students: 160,
      image: IMG.students,
      banner: IMG.students,
      department: 'Computer Engineering',
      duration: 'Half day · 3 hours',
      sessions: 2,
      speakersCount: 3,
      hours: 3,
      regStatus: 'Opening soon',
      regSeats: '160 seats',
      regFee: 'Free for students',
      regDeadline: 'Registration opens 20 Aug 2026',
      countdownIso: '2026-09-14T10:30:00+05:30',
      summary: 'A career session with mock interviews and a .NET skills roadmap, run with VGEC’s placement cell.',
      objective: 'Prepare final-year students for the .NET job market with real hiring insight and hands-on mock interviews.',
      audience: 'Pre-final and final-year Computer Engineering students.',
      overview: [
        'In partnership with VGEC’s placement cell, UUGI runs a practical career session combining a clear .NET skills roadmap with live mock interviews.',
        'Students get direct, honest feedback from working developers — the kind of preparation that turns campus interviews into offers.'
      ],
      agenda: [
        { time: '10:30', title: 'The .NET Skills Roadmap', desc: 'What to learn, in what order, and why.' },
        { time: '11:30', title: 'Mock Interviews', desc: 'Live, feedback-driven practice with mentors.' },
        { time: '13:00', title: 'Open Career Clinic', desc: 'Resumes, portfolios and one-on-one advice.' }
      ],
      topics: ['.NET Career Roadmap', 'Skills Agencies Hire For', 'Mock Technical Interviews', 'Portfolio Reviews', 'Certifications That Matter'],
      speakers: [
        { name: 'Rajat Verma', role: 'Chapter Lead', org: 'UUGI Delhi' },
        { name: 'Sameer Khanna', role: 'Partnerships', org: 'UUGI Delhi' },
        { name: 'Lakshmi Iyengar', role: 'Community', org: 'UUGI Kochi' }
      ],
      expected: ['160 students career-prepped', '40+ mock interviews conducted', 'Placement cell partnership renewed', 'Mentor pool for ongoing support']
    }
  ];

  function byId(id) {
    for (var i = 0; i < programs.length; i++) {
      if (programs[i].id === id) return programs[i];
    }
    return null;
  }

  window.UUGI_EDU = {
    programs: programs,
    byId: byId,
    images: IMG,
    galleries: { a: GAL_A, b: GAL_B }
  };

})();
